import type { MutableRefObject } from "react";
import { useEffect, useRef } from "react";
import type { CompareV2DispatchType } from "../redux/store";
import { compareChangeColour } from "../redux/actions/NewCarCompareActions";
import { useDispatch } from "../../../shared-logic/redux/store";

type useSelectSwatchReturnType = {
    changeColour: (colourCode: string) => void;
    wrapperRef: MutableRefObject<HTMLDivElement | null>;
};

const useSelectSwatch = (
    index: number,
    swatchSelectHeight: number,
    setSwatchSelectHeight: (height: number) => void,
): useSelectSwatchReturnType => {
    const dispatch = useDispatch<CompareV2DispatchType>();

    // update swatch height
    const wrapperRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (wrapperRef.current) {
            const newHeight = wrapperRef.current.offsetHeight;
            if (newHeight > swatchSelectHeight) {
                setSwatchSelectHeight(newHeight);
            }
        }
    });

    const changeColour = (colourCode: string): void => {
        dispatch(compareChangeColour(colourCode, index));
    };

    return {
        changeColour,
        wrapperRef,
    };
};

export default useSelectSwatch;
